export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;
export const FB_DOMAIN_VERIFICATION_ID =
  process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION_ID;
export const FB_SANTA_POLA_PIXEL_ID =
  process.env.NEXT_PUBLIC_FACEBOOK_SANTA_POLA_PIXEL_ID;

export const pageview = () => {
  window['fbq'] && window['fbq']('track', 'PageView');
};
